import React from 'react'
import {IconButton} from '@chakra-ui/react'
import {ArrowBackIcon} from '@chakra-ui/icons'

export default (props) => (
  <IconButton variant="tertiary" isRound aria-label="Back" {...props}>
    <ArrowBackIcon />
  </IconButton>
)
